// src/components/kuestion/shared/ThemeContext.jsx
// One useTheme instance per app root, shared down so every toggle button in
// the tree re-renders together. Same :root[data-theme] + localStorage
// contract as the website.
import React, { createContext, useContext } from 'react';
import useTheme from '../../../hooks/useTheme';
import { SunIcon, MoonIcon } from './Icons';

const ThemeCtx = createContext({ theme: 'light', toggleTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, toggleTheme] = useTheme();
  return <ThemeCtx.Provider value={{ theme, toggleTheme }}>{children}</ThemeCtx.Provider>;
};

export const useThemeCtx = () => useContext(ThemeCtx);

export const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useThemeCtx();
  const dark = theme === 'dark';
  return (
    <button type="button" className={`kqc-iconbtn ${className}`} onClick={toggleTheme} title={dark ? 'Switch to light' : 'Switch to dark'}>
      {dark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
};
